import TYPES from '@/types';

// Domain
import {
  InvestorProfileOnCustomGoalRepository,
} from '@/modules/flagship/investor-profile/custom-goal/domain/repositories/investor-profile-on-custom-goal-repository';
import { InvestorProfileEntity } from '../../../investor-profile/domain/entities/investor-profile-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class InvestorProfileOnCustomGoalHttpRepository
implements InvestorProfileOnCustomGoalRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-profile/custom-goals/{investor_profile_id}/`;

  update(investor_profile_entity: InvestorProfileEntity): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.replace('{investor_profile_id}', investor_profile_entity.id!), 'PATCH', {
        custom_goals: investor_profile_entity.custom_goals,
      })
        .then((response) => {
          if (response.ok) {
            resolve();
          } else {
            response.json().then(
              ({ message }) => {
                reject(new Error(message));
              },
            );
          }
        })
        .catch(reject);
    });
  }
}
